var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x30_1._Facebook",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.261,
    height: 44.975,
    viewBox: "0 0 24.261 44.975",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_11_",
    d: "M35.155,35.486H29.582c-.9,0-1.182-.338-1.182-1.182V27.493c0-.9.338-1.182,1.182-1.182h5.573V21.358A12.5,12.5,0,0,1,36.674,15a9.34,9.34,0,0,1,5.01-4.165,12.524,12.524,0,0,1,4.334-.732h5.516c.788,0,1.126.338,1.126,1.126v6.417c0,.788-.338,1.126-1.126,1.126-1.52,0-3.04,0-4.559.056a2.032,2.032,0,0,0-2.308,2.308c-.056,1.689,0,3.321,0,5.066H51.2c.9,0,1.238.338,1.238,1.238v6.811c0,.9-.281,1.182-1.238,1.182h-6.53V53.78c0,.957-.281,1.295-1.295,1.295H36.337c-.844,0-1.182-.338-1.182-1.182V35.486Z",
    transform: "translate(-28.4 -10.1)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.fcbc38524cf0d4c7ba30ba5c425d24c1.svg";
export { ForwardRef as ReactComponent };